// Placeholder de IA para legendas de fotos/vídeos (DialogFotos/DialogVideos).
// Será substituído pela integração real (edge function ai-chat) futuramente.
// Os antigos catálogos mock (materiais/equipamentos/colaboradores) foram
// removidos na Fase 6 — os dados reais vêm dos caches do Supabase.
export const fakeAiCaption = async (input: string | File): Promise<string> => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));

  if (input instanceof File) {
    return `Imagem mostrando ${input.name.split('.')[0]} - análise automática gerada por IA.`;
  }

  // For text correction
  return input.replace(/\b\w/g, (l) => l.toUpperCase());
};
